import styled from 'styled-components'
import { Image } from '@/features/shared/elements/Image/NextImage'
import { objectStorageUrl } from '@/features/shared/utils/objectStorageUrl'

type Props = {
  height?: number
  width?: number
  inverse?: boolean
}
export const C360Logo = ({ height = 15, width = 85, inverse }: Props) => {
  return (
    <LogoImage
      alt="Target Circle 360™"
      width={width}
      height={height}
      src={objectStorageUrl(inverse ? 'circle_360_white.svg' : 'circle_360_red.svg')}
      unoptimized
    />
  )
}

const LogoImage = styled(Image)`
  vertical-align: middle;
`
